import {
  GENERATEWALLETTRANSACTIONREPORTFILE_SUCCESS,
  GENERATEWALLETTRANSACTIONREPORTFILE_FAILED,
  RESET_GENERATEWALLETTRANSACTIONREPORTFILE,
  LOADING_GENERATEWALLETTRANSACTIONREPORTFILE,
  NETWORK_ERROR_GENERATEWALLETTRANSACTIONREPORTFILE,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGenerateWalletTransactionReportFile = () => {
  return { type: RESET_GENERATEWALLETTRANSACTIONREPORTFILE };
};

// const generateWalletTransactionReportFileReq =
//   (userData, authTokenIs) => async (dispatch) => {
//     dispatch({ type: LOADING_GENERATEWALLETTRANSACTIONREPORTFILE });
//     await partnerServices
//       .post(
//         "generateWalletTransactionReportFile", userData, { headers: { AuthToken: authTokenIs } }
//       )
//       .then((res) => {
//         switch (res.data.status) {
//           case "success":
//             dispatch(generateWalletTransactionReportFileSuccess(res.data));
//             break;
//           default:
//             dispatch(generateWalletTransactionReportFileFailed(res.data));
//             break;
//         }
//       })
//       .catch((err) => {
//         dispatch({
//           type: NETWORK_ERROR_GENERATEWALLETTRANSACTIONREPORTFILE,
//           payload: err,
//         });
//       });
//   };


const generateWalletTransactionReportFileReq =
  (userData, authTokenIs, fileType) => async (dispatch) => {  // ✅ added fileType param
    dispatch({ type: LOADING_GENERATEWALLETTRANSACTIONREPORTFILE });
    await partnerServices
      .post(
        "generateWalletTransactionReportFile",
        userData,
        {
          headers: { AuthToken: authTokenIs },
          responseType: "blob", // ✅ KEY FIX — treat response as binary
        }
      )
      .then((res) => {
        // ✅ No res.data.status check — blob has no JSON body
        dispatch(generateWalletTransactionReportFileSuccess({
          status: "success",  // ✅ we set this manually
          blob: res.data,     // ✅ raw binary blob
          fileType: fileType, // ✅ "csv" or "pdf"
        }));
      })
      .catch((err) => {
        // ✅ If server returns error as JSON blob, parse it back
        if (err.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result);
              dispatch(generateWalletTransactionReportFileFailed(errorJson));
            } catch {
              dispatch(generateWalletTransactionReportFileFailed({ message: "Unknown error" }));
            }
          };
          reader.readAsText(err.response.data);
        } else {
          dispatch({
            type: NETWORK_ERROR_GENERATEWALLETTRANSACTIONREPORTFILE,
            payload: err,
          });
        }
      });
  };
function generateWalletTransactionReportFileSuccess(data) {
  return {
    type: GENERATEWALLETTRANSACTIONREPORTFILE_SUCCESS,
    payload: data,
  };
}
function generateWalletTransactionReportFileFailed(data) {
  return {
    type: GENERATEWALLETTRANSACTIONREPORTFILE_FAILED,
    payload: data,
  };
}

export {
  resetGenerateWalletTransactionReportFile,
  generateWalletTransactionReportFileReq,
};
